<!-- 空白错误页 -->
<template>
  <div class="error_page">
    <h1 v-if="error.statusCode === 206">206 page not found</h1>
  </div>
</template>

<script>
export default {
  /* eslint-disable-next-line */
  props: ['error'],
  layout: 'error-layout'
};
</script>
